import { render, staticRenderFns } from "./DEllipse.vue?vue&type=template&id=f3405cda&scoped=true"
import script from "./DEllipse.vue?vue&type=script&lang=js"
export * from "./DEllipse.vue?vue&type=script&lang=js"
import style0 from "./DEllipse.vue?vue&type=style&index=0&id=f3405cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3405cda",
  null
  
)

export default component.exports